<template>
    <div>
        <div class="designeroption" v-show="panel_required">
            <tile-question-layout :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title"
                                  :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list"
                                  :thumb_url="thumbURL"
                                  :component_id="component_id"
                                  :fabricator="fabricator"
            ></tile-question-layout>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Glass Backing Design';
                }
            },
            component_id: {
                default(){
                    return 'glass_backing_design';
                }
            },
            glassDesign: {
                required: true,
            },
            slab: {
                required: true,
            },
            doorRange: {
                required: false,
                default() {
                    return '';
                }
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/glass/';
            },
            passed_filter(){
                return this.variable_ready(this.glassDesign, this.slab, this.doorRange)
            },
            url(){
                return '/api/options/' + this.fabricator + '/glass-backing-design?slab=' + this.slab + '&glass_design=' + this.glassDesign + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.glassDesign + '_' + this.slab + '_' + this.doorRange;
            },
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 0;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
